import { useEffect, useState } from "react";
import { Grid, Button, FormControl, InputLabel, Select, MenuItem  } from "@material-ui/core"
import * as yup from "yup";
import { useFormik } from "formik";
import { useDispatch } from "react-redux";
import { ToastMessage } from "../../../global/ToastMessage";
import { obtenerMensualidadesBanco, agregarMensulidadBanco, actulizaMensualidadBanco, obtenerMensualidadBanco } from "../../../ducks/bancoDuck"
import { onLoadAnction, offLoadAction } from "../../../ducks/loadDuck"
import { useSelector } from "react-redux";
import FieldMain from "../../../global/FieldMain";

const validationSchema = yup.object({
    tasaCobro: yup.number("Ingresa un apellido paterno").required("Tasa de cobro es requerido"),
})

const InitalValues = {
    tasaCobro: "",
}
const ArrayFormValues = [
    {
        name: "tasaCobro",
        type: "number",
        label: "Tasa de cobro %",
        width: "97%"
    },
]
const FMensualidad = () => {
    const { editarMensualidadBanco, mensualidadBanco, banco, listaMensualidades } = useSelector(store => store.banco)
    const dispatch = useDispatch()
    const [mensualidad, setMensualidad] = useState(0)
    const formik = useFormik({
        initialValues: InitalValues,
        validationSchema: validationSchema,
        onSubmit: (values) => handleSubmit(values),
    })
    const handleSelecMensualidad = (event) => {
        setMensualidad(event.target.value)
    }
    const handleSubmit = (values) => {
        let payload = {
            SobreTasa: values.tasaCobro,
            IdBanco: banco.IdBanco,
            IdMensualidad: mensualidad
        }
        dispatch(onLoadAnction({ message: "" }))
        if (editarMensualidadBanco) {
            payload.IdBancoMensualidad = mensualidadBanco.IdBancoMensualidad
            dispatch(actulizaMensualidadBanco(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerMensualidadesBanco({ IdBanco: banco.IdBanco }))
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        } else {
            dispatch(agregarMensulidadBanco(payload)).then(Response => {
                dispatch(offLoadAction())
                if (Response.status === 500) {
                    ToastMessage.fire({
                        icon: "error",
                        title: "Ha habido un problema intentar mas tarde",
                    });
                    return null;
                }
                if (Response.status === 400) {
                    ToastMessage.fire({
                        icon: "error",
                        title: Response.Message,
                    });
                    return null;
                }
                dispatch(obtenerMensualidadesBanco({ IdBanco: banco.IdBanco }))
                clearForm()
                ToastMessage.fire({
                    icon: "success",
                    title: "Ingreso Correcto",
                });
            })
        }
    }

    useEffect(() => {
        const formLoad = () => {
            formik.setFieldValue("tasaCobro", mensualidadBanco?.SobreTasa)
            setMensualidad(mensualidadBanco?.Mensualidad?.IdMensualidad)
        }
        if (editarMensualidadBanco)
            formLoad()
        else
            formik.resetForm(InitalValues)
    }, [editarMensualidadBanco, mensualidadBanco.IdBancoMensualidad]) //eslint-disable-line

    const handleCancel = () => {
        clearForm()
    }
    const clearForm = () => {
        formik.resetForm(InitalValues)
        setMensualidad(0)
        dispatch(obtenerMensualidadBanco({mensualidadBanco: {}, editar: false}))
    }
    return (
        <form onSubmit={formik.handleSubmit}>
            <Grid container>
                <Grid item xs={12}>
                    {
                        <h4 style={{ textAlign: "center" }}>{(editarMensualidadBanco) ? "Editar Mensualidad" : "Nuevo Mensualidad"}</h4>
                    }
                </Grid>
                <Grid item xs={12}>
                    <FormControl variant="outlined" style={{width: "97%"}} >
                        <InputLabel id="lMensualidades">Mensualiadades</InputLabel>
                        <Select
                            labelId="lMensualidades"
                            id="SlMensualidades"
                            name="mensualidades"
                            value={mensualidad}
                            onChange={handleSelecMensualidad}
                            label="Acción"
                        >
                            <MenuItem value={0}>
                                {"Seleccione una opción"}
                            </MenuItem>
                            {listaMensualidades.map((item, index) => (
                                <MenuItem key={item.IdMensualidad} value={item.IdMensualidad}>
                                    {`${item.Cantidad} Meses`}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>
                {
                    ArrayFormValues.map((item, index) =>
                        <Grid item xs={12} key={item.name}>
                            <FieldMain
                                name={item.name}
                                label={item.label}
                                type={item.type}
                                width={item.width}
                                formik={formik}
                            />
                        </Grid>
                    )
                }
                <Grid item xs={12}>
                    <div style={{ display: "flex", flexFlow: "row", justifyContent: "flex-start", alignItems: "flex-end", gap: "1rem" }}>
                        <Button
                            style={{ margin: "0 2%" }}
                            variant="contained"
                            color="primary"
                            type="submit"
                        >
                            Guardar
                        </Button>
                        {
                            (editarMensualidadBanco) &&
                            <Button
                                style={{ margin: "0 2%" }}
                                variant="contained"
                                color="default"
                                onClick={handleCancel}
                            >
                                Camcelar
                            </Button>
                        }
                    </div>

                </Grid>
            </Grid>
        </form>
    )
}
export default FMensualidad